import { gql } from "@apollo/client"
import { InjectedOptions, useMutation } from "@oysterhr/core"
import {
  UpdatePaymentMethodPurposeInput,
  UpdatePaymentMethodPurposePayload,
} from "@oysterhr/schema"

const UPDATE_PAYMENT_METHOD_PURPOSE_MUTATION = gql`
  mutation UpdatePaymentMethodPurpose(
    $paymentMethodId: ID!
    $purpose: PaymentMethodPurposeEnumType!
  ) {
    updatePaymentMethodPurpose(input: { paymentMethodId: $paymentMethodId, purpose: $purpose }) {
      paymentMethod {
        ... on PaymentMethodStripeAch {
          id
          purpose
        }
        ... on PaymentMethodStripeSepa {
          id
          purpose
        }
        ... on PaymentMethodStripeBacs {
          id
          purpose
        }
        ... on PaymentMethodStripePad {
          id
          purpose
        }
      }
      errors
    }
  }
`

export const useUpdatePaymentMethodPurpose = (
  options?: InjectedOptions<
    { updatePaymentMethodPurpose: UpdatePaymentMethodPurposePayload },
    UpdatePaymentMethodPurposeInput
  >,
) => useMutation(UPDATE_PAYMENT_METHOD_PURPOSE_MUTATION, options)
